import React from "react";
import { CalendarIcon, PlusIcon } from "@phosphor-icons/react";
import "./events.css";

interface NoEventStateProps {
  isAdmin: boolean;
  hasExistingEvents: boolean;
  onCreateEvent?: () => void;
}

const NoEventState: React.FC<NoEventStateProps> = ({
  isAdmin,
  hasExistingEvents,
  onCreateEvent,
}) => {
  const title = hasExistingEvents
    ? "Nessun evento futuro"
    : "Nessun evento disponibile";
  let description: string;

  if (hasExistingEvents) {
    description = isAdmin
      ? "Tutti gli eventi del gruppo sono passati. Crea un nuovo evento per continuare a organizzare i regali."
      : "Tutti gli eventi disponibili sono passati. Attendi che l'amministratore crei un nuovo evento.";
  } else {
    description = isAdmin
      ? "Crea il primo evento per iniziare a organizzare i regali."
      : "Non ci sono ancora eventi per questo gruppo. Attendi che l'amministratore ne crei uno.";
  }

  const actionLabel = hasExistingEvents
    ? "Crea un nuovo evento"
    : "Crea il primo evento";

  return (
    <div className="no-event-state">
      <div className="no-event-state-icon">
        <CalendarIcon size={48} weight="light" />
      </div>
      <h2>{title}</h2>
      <p>{description}</p>
      {isAdmin && onCreateEvent && (
        <button
          type="button"
          className="no-event-state-action"
          onClick={onCreateEvent}
        >
          <PlusIcon size={18} weight="bold" />
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default NoEventState;
